import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '../../../../shared/supported-locales.js';
import { useSiteLang } from '../../layout/use-site-lang.js';
import { WorldMap } from '../world-map.jsx';

/**
 * "Available in your language" use-case mockup: a world map shading the
 * countries where a Thyme language is spoken (two orientations, chosen by the
 * active locale), a marketing callout, and the list of supported languages.
 * @returns {JSX.Element}
 */
export function LanguageScreen() {
	const { t } = useTranslation();
	const lang = useSiteLang();

	return (
		<>
			<div className="card language-map-card">
				<WorldMap />
			</div>
			<div className="use-case-callout card">
				<h3>{t('usecase.language.callout.title')}</h3>
				<p>{t('usecase.language.callout.body')}</p>
			</div>
			<div className="card language-list-card">
				<h3>{t('usecase.language.langsTitle')}</h3>
				<ul className="language-list">
					{SUPPORTED_LOCALES.map((code) => (
						<li key={code} className={code === lang ? 'active' : undefined}>
							{t(`language.${code}`)}
						</li>
					))}
				</ul>
				<p className="language-list-note">{t('usecase.language.langsNote')}</p>
			</div>
		</>
	);
}
